import React from "react";
import "./work.css";
import Works from "./Works";
import Icon from "../ui/Icon";
import Reveal from "../ui/Reveal";
import { projects, GITHUB } from "./Data";

const Work = ({ onOpenProject }) => (
  <section className="work section" id="work" aria-labelledby="work-title">
    <div className="container">
      <Reveal as="header" className="section__head">
        <span className="eyebrow">01 — Work</span>
        <h2 id="work-title" className="section__title">
          Selected work
        </h2>
        <p className="section__lead">The problem, the design and what comes next, one case file per project.</p>
      </Reveal>

      <Works items={projects} bento onOpenProject={onOpenProject} />

      <p className="work__more">
        More experiments and coursework live on{" "}
        <a href={GITHUB} target="_blank" rel="noreferrer">
          GitHub <Icon name="external" />
          <span className="sr-only"> (opens in a new tab)</span>
        </a>
        .
      </p>
    </div>
  </section>
);

export default Work;
